<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <h1>Provision Invoice Batch Monitoring</h1>
        <p class="subtitle-1">Monitor and explore provision invoice batch processing</p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Recent Batches
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="refreshBatches" :loading="loading">
              <v-icon left>mdi-refresh</v-icon>
              Refresh
            </v-btn>
          </v-card-title>
          <v-card-text>
            <provision-batch-table
              :batches="recentBatches"
              @select-batch="selectBatch"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="selectedBatch">
      <v-col cols="12">
        <provision-batch-details
          :batch="selectedBatch"
          :summary="selectedBatchSummary"
          @close="closeDetails"
        />
      </v-col>
    </v-row>

    <v-snackbar v-model="errorSnackbar" color="error" timeout="5000">
      {{ error }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ProvisionBatchTable from "../components/ProvisionBatch/ProvisionBatchTable";
import ProvisionBatchDetails from "../components/ProvisionBatch/ProvisionBatchDetails";

export default {
    name: "ProvisionBatchMonitoring",
    components: {
        ProvisionBatchTable,
        ProvisionBatchDetails
    },
    computed: {
        ...mapGetters("provisionBatch", [
            "recentBatches",
            "selectedBatch",
            "selectedBatchSummary",
            "loading",
            "error"
        ]),
        errorSnackbar: {
            get() {
                return !!this.error;
            },
            set() {
                // Close snackbar
            }
        }
    },
    methods: {
        ...mapActions("provisionBatch", [
            "fetchRecentBatches",
            "fetchBatchDetails",
            "fetchBatchAreaSummary",
            "clearSelectedBatch"
        ]),
        async refreshBatches() {
            await this.fetchRecentBatches(20);
        },
        async selectBatch(batchId) {
            await Promise.all([
                this.fetchBatchDetails(batchId),
                this.fetchBatchAreaSummary(batchId)
            ]);
        },
        closeDetails() {
            this.clearSelectedBatch();
        }
    },
    mounted() {
        this.refreshBatches();
    }
};
</script>
